export default "__VITE_ASSET__s3sztcH8__"